import {
  ProcessingConfig,
} from '../types/create';
import { simulateApiDelay } from '../utils';

/**
 * API Service for Knowledge Management
 */
export class KnowledgeApiService {

  /**
   * Fetch processing configuration
   */
  static async fetchProcessingConfig(): Promise<ProcessingConfig> {
    try {
      const response = await fetch('/api/datasets/process-rule', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch processing config');
      }

      return await response.json();
    } catch (error) {
      console.error('Failed to fetch processing config:', error);

      // Fallback to mock response
      await simulateApiDelay();
      return {
        mode: "high_quality",
        rules: {
          preProcessingRules: [
            { id: "remove_extra_spaces", enabled: true },
            { id: "remove_urls_emails", enabled: false },
            { id: "qa_generation", enabled: true }
          ],
          segmentation: {
            delimiter: "\n",
            maxTokens: 1024,
            chunkOverlap: 50
          }
        },
        limits: {
          indexingMaxSegmentationTokensLength: 4000
        }
      };
    }
  }

}
